import { rem, radius } from '@thiememeulenhoff/lit-sdk';
import { css } from 'lit';

export const styles = css`
  :host {
    display: block;
    inline-size: 100%;
  }
  :where(.placeholder-button) {
    block-size: ${rem(60)};
    border-radius: ${radius('small')};
    inline-size: ${rem(60)};
    inset-block-start: 50%;
    inset-inline-start: 50%;
    position: absolute;
    transform: translate(-50%, -50%);
  }
`;
